import React from 'react'; 
 import {
    fromJS
} from 'immutable';
 
import {
  connect
} from 'react-redux';
import {
  actionCreators
} from './store';
import history from 'common/history';
import './index.css';
import {    Drawer, List,  Icon, InputItem, } from 'antd-mobile';
import TagItem from './components/tagItem' 
import Header from 'component/mobile_header' 
import SelectBar from './components/selectBar'
import ListView from './components/listView'
import Sidebar from './components/sidebar'

  
class Course extends React.Component{
  state = {
    open: false,
    type:'',
    data:[],
    page:1,
      title:'课程'
  }
 

  componentWillMount(){
    const { 
            getCourseList,
            projectList,
            liveList,
            experimentList,
            getCategoryData,
            changeSearchTitle,
            changeCateId,
            clearList
          } = this.props;
    let str = this.getSubString(this.props.match.path)
    clearList(str)
    changeSearchTitle('')
    changeCateId('')
    if(str==='experiment'){
        this.setState({title:'实验课程'});
      // if( experimentList===undefined){
          getCourseList('experiment', 1);
      // }
      
      this.setState({ 
        type:'experiment',
      });
    }else if(str==='project'){
        this.setState({title:'专题课程'});
      // if( projectList===undefined){
        getCourseList('project', 1);
      // }
      
      this.setState({ 
        type:'project',
      });

    }else if(str==='live'){
        this.setState({title:'直播课程'});
      // if( liveList===undefined){
        getCourseList('live', 1);
      // }
      this.setState({ 
        type:'live',
      });
    }
    getCategoryData()
  }
  componentWillReceiveProps(nextProps,nextState) {
    if(nextState.type!==this.state.type){
       if (this.props.projectList && nextProps.projectList.toJS() !== this.props.projectList.toJS()) {
     setTimeout(() => { 
             this.setState({
                data:nextProps.projectList.toJS() 
              }); 
            }, 600);
        }
    }else if(nextState.type===this.state.type){
       if (this.props.projectList && nextProps.projectList.toJS() !== this.props.projectList.toJS()) {
       setTimeout(() => { 
          let data = this.state.data.concat(nextProps.projectList.toJS())
           this.setState({
              data
            }); 
          }, 600);
        }
    }
  }
  
  onOpenChange = (...args) => {
    this.setState({ 
      open: !this.state.open,
    });
  }
  sideClick(value,cateId){ 
    const{changeSearchTitle,getCourseList,changeCateId}=this.props;
    const{type}=this.state

    this.onOpenChange()
    changeSearchTitle(value)
    this.clearList()
    changeCateId(cateId)
    getCourseList(type, '', '',value,cateId)
  }
  getSubString(str){
    let index = str .lastIndexOf("\/");  
    str = str .substring(index + 1, str .length);
    return str
  }
  changePage(page){ 
    const {getCourseList,changePageSize,searchTitle} =this.props;
    const {type}=this.state;
    getCourseList(type,page,"",searchTitle);
    changePageSize(page,type)
  }
  clearList(){
    const {clearList} = this.props;
    const {type} = this.state;
    clearList(type)
  }
  getSelectList(sort){
      const{getCourseList,clearList,searchCateId,searchTitle}=this.props;
      const {type} = this.state;
      clearList(type);
      searchCateId?getCourseList(type, '', '',searchTitle,searchCateId.toJSON(),sort):getCourseList(type, '', '',searchTitle,searchCateId,sort)
  }
  render(){
    const { 
            projectList,
            liveList,
            experimentList,
            changeNewLists,
            totalPage,
            newProjectList,
            newLiveList,
            newExperList,
            projectPage, 
            livePage,
            experPage,
            categoryList,
          } = this.props;
    const {type} = this.state;
    let list = '';
    let page=1
    if( type==='project' && newProjectList && newProjectList.size!=0){
      list = newProjectList.toJS()
      page={projectPage}
    }else if( type==='live'&& newLiveList && newLiveList.size!=0){
      list = newLiveList.toJS()
      page={livePage}
    }else if( type==='experiment'&& newExperList && newExperList.size!=0){
      list = newExperList.toJS()
      page={experPage}
    }
    return (
       <Drawer
          className="my-drawer"
          style={{ minHeight: document.documentElement.clientHeight }}
          enableDragHandle
          contentStyle={{ color: '#A6A6A6', textAlign: 'center', paddingTop: 42 }}
          sidebar={<Sidebar 
            sideClick={(value,cateId)=>{this.sideClick(value,cateId)}}  
            categoryList={categoryList}/>}
          open={this.state.open}
          onOpenChange={this.onOpenChange}
          position={'right'}>
        <Header title = {this.state.title}/>
        <div className="container-course">
          <SelectBar
            getSelectList={(sort)=>{this.getSelectList(sort)}} 
            open={()=>{this.onOpenChange()}} 
            />
           <div className="listView-box">
             <ListView 
               data={list} 
               getData = {(page)=>{this.changePage(page)}} 
               totalPage = {totalPage}
               clear={()=>{this.clearList()}}
               page={projectPage}
               />
           </div>
        </div>  
      </Drawer> 
      )
  }
}
const mapState = (state) => ({ 
  projectList: state.getIn(['course','project','models']),
  liveList: state.getIn(['course','live','models']),
  experimentList: state.getIn(['course','experiment','models']),
  totalPage:state.getIn(['course','totalPage']),
  newProjectList:state.getIn(['course','newProjectList']),
  newLiveList:state.getIn(['course','newLiveList']),
  newExperList:state.getIn(['course','newExperList']),
  projectPage:state.getIn(['course','projectPage']),
  livePage:state.getIn(['course','livePage']),
  experPage:state.getIn(['course','experPage']),
  categoryList:state.getIn(['course','categoryList']),
  searchCateId:state.getIn(['course','searchCateId']),
  searchTitle:state.getIn(['course','searchTitle']),

})
const mapDispatch = (dispatch) => ({
  getCourseList(types, page, perpage,title,cate,sort) {
    dispatch(actionCreators.getCourseList(types, page, perpage,title,cate,sort))
  },
  changeNewLists(data){
    dispatch(actionCreators.changeNewLists(data))
  },
  clearList(type){
    dispatch(actionCreators.clearList(type))
  },
  clearSearchData(){
    dispatch(actionCreators.clearSearchData())
  },
  changePageSize(page,type){
    dispatch(actionCreators.changePageSize(page,type))
  }, 
  getCategoryData(){
    dispatch(actionCreators.getCategoryData())
  },
  changeSearchTitle(title){
    dispatch(actionCreators.changeSearchTitle(title))
  },
  changeCateId(id){
    dispatch(actionCreators.changeCateId(id))
  }
})
export default connect(mapState, mapDispatch)(Course);
